import { useContext } from "react";
import { createBrowserHistory } from "history";
import UserPersonalInfo from "../../../../components/personalInfo/UserPersonalInfo";
import { useAuth } from "../../../../context/AuthContext";
import { updateCandidateData } from "../../../../api/endpoints/candidate/cadidates";

export default function PersonalInfoCandidate() {
  const userContext = useAuth();
  const history = createBrowserHistory();
  const afterSubmit = () => {
    history.go(0);
  };
  return (
    <div className="flex flex-col bg-gray-50   items-center w-full">
      <UserPersonalInfo
        updateUser={updateCandidateData}
        user={userContext?.currentUser!}
        afterSubmit={afterSubmit}
        isEditable={true}
        candidateStatus={true}
        stylesClass={"md:bg-white  md:p-6 "}
      />
    </div>
  );
}
